// extracted by mini-css-extract-plugin
export default {"authLayoutLogo":"logo_authLayoutLogo__6oZCB","authLogoPartOne":"logo_authLogoPartOne__Z6tO4","authLogoPartTwo":"logo_authLogoPartTwo__kw30R","mTradeLogo":"logo_mTradeLogo__tPnTB"};